export const RESOLUTION = 'RESOLUTION';
export const TRACK_ROLL = 'TRACK_ROLL';
export const SEQUENCE_ROLL = 'SEQUENCE_ROLL';
export const PATTERN_SWITCH = 'PATTERN_SWITCH';
export const BPM = 'BPM';
export const SWING = 'SWING';
export const NEXT_PATTERN = 'NEXT_PATTERN';
export const PREVIOUS_PATTERN = 'PREVIOUS_PATTERN';
